import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SenderInfoResetComponent } from './sender-info-reset.component';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { InputCheckComponent } from './input-check/input-check.component';
import { ReactiveFormsModule } from '@angular/forms';
import { GalaxyWrapModule } from '@vendasta/galaxy/galaxy-wrap';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SenderInfoResetService } from './sender-info-reset.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { EmailUII18nModule } from '../../src/lib/i18n/email-ui-i18n.module';

@NgModule({
  declarations: [SenderInfoResetComponent, InputCheckComponent],
  providers: [SenderInfoResetService],
  exports: [SenderInfoResetComponent],
  imports: [
    CommonModule,
    TranslateModule,
    EmailUII18nModule,
    GalaxyEmptyStateModule,
    ReactiveFormsModule,
    GalaxyWrapModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    GalaxyTooltipModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
})
export class SenderInfoResetModule {}
